import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const CheckFilled: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", width = 24, height = 24, ...rest }, ref) => <svg ref={ref} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <circle cx="12" cy="12" r="10" fill={color}/>
   <path d="M8 12.0003L11.1521 15.3337L17 8.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
</svg>);
export default CheckFilled;